/* eslint-disable react/jsx-key */
import {
  ComparisonHeaderItem, ComparisonTable as Table, ComparisonTableThemes, TagTheme
} from 'member-web-shared-components';
import './ComparisonTieredTable.scss';
import { ComparisonTieredTableProps } from '../../types/App';

const ComparisonTieredTable = (props: ComparisonTieredTableProps) => {
  const {
    componentId,
    comparisonTableTitle,
    comparisonTableDescription,
    comparisonTableDisclaimer
  } = props;

  const comparisonHeaderItems: ComparisonHeaderItem[] = [
    { title: 'Lite', description: 'Best for local driving, here and there.', tag: { text: 'BETA', theme: TagTheme.WARNING } },
    { title: 'Standard', description: 'Great for the occasional driver.', tag: { text: 'CURRENT PLAN', theme: TagTheme.NEUTRAL } },
    { title: 'Plus', description: 'Perfect if you\'re a frequent driver.', tag: { text: 'BETA', theme: TagTheme.WARNING } }
  ];

  return (
    <div
      data-testid={componentId}
      className='presales-comparison-table'
    >
      <Table
        data={{
          comparisonHeaderItems,
          comparisonItems: [
            {
              title: 'Monthly cost',
              comparison: [
                '$5',
                '$9',
                '$19'
              ]
            },
            {
              title: 'Gas always on us',
              comparison: [
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />,
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />,
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />
              ]
            },
            {
              title: 'Insurance options included',
              comparison: [
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />,
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />,
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />
              ]
            },
            {
              title: '24/7 support',
              comparison: [
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />,
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />,
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />
              ]
            },
            {
              title: '15 minute early access to trips',
              comparison: [
                <img alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />,
                <img alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />,
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />
              ]
            },
            {
              title: '$10 monthly credit',
              comparison: [
                <img alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />,
                <img alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />,
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />
              ]
            },
            {
              title: '1 extra driver included<sup>1</sup>',
              comparison: [
                <img alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />,
                <img alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />,
                <img alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />
              ]
            },
            {
              title: 'Additional extra drivers at 50% OFF<sup>2</sup>',
              comparison: [
                <img alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />,
                '1',
                '2'
              ]
            },
            {
              title: 'Miles included per day',
              comparison: [
                '50',
                '200',
                '300'
              ]
            },
            {
              title: 'Cost per additional mile',
              comparison: [
                '$0.58',
                '$0.58',
                '$0.38'
              ]
            },
            {
              title: 'Trip cancellation policy',
              comparison: [
                '24 hours before trip start time<sup>3</sup>',
                'Same-day flexibility for trips under 8 hours<sup>4</sup>',
                'Same-day flexibility for trips under 8 hours<sup>4</sup>'
              ]
            }
          ]
        }}
        description={comparisonTableDescription}
        disclaimer={comparisonTableDisclaimer}
        title={comparisonTableTitle}
        theme={ComparisonTableThemes.ALTERNATE}
      />
    </div>
  );
};

export default ComparisonTieredTable;
